module.exports = __webpack_public_path__ + "tables/media/E-commerce_filled.0b38a3a9.svg";